import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import CompanyTable from "./CompanyTable";

const CompanyList = () => {
    return (
        <Fragment>
            <CompanyTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default CompanyList;